angular
  .module('capability-ng-resources')
  .constant('ResourceDetailsBuilderDTD', {
    nk: 'string',
    order: 'number',
    resource: 'number',
    resource_display_type: {
      type: 'enum',
      typeDef: 'ResourceLinks',
      writeToKey: 'type',
      defaultValue: 'generic'
    },
    value: 'string'
  })
  .factory('ResourceDetailsBuilder', function (Interface, ResourceDetailsBuilderDTD) {
    return function ResourceDetailsBuilderDTO(data) {
      if (!(this instanceof ResourceDetailsBuilderDTO)) {
        return new ResourceDetailsBuilderDTO(data);
      }

      Interface.implement(ResourceDetailsBuilderDTD, data, this);
    };
  });



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/builders/resource_details_builder.es.js